module.exports = __webpack_public_path__ + "static/media/06-mobile-3.97d28ae2.png";